export default {
    fileUpload: {
        clickToUpload: "Click to upload",
        andAttachFiles: "and attach files",
        orDragAndDrop: "or drag and drop",
        defaultHint: "SVG, PNG, JPG or GIF (max. 800x400px)",
        complete: "Complete",
        uploading: "Uploading...",
        failed: "Failed",
        delete: "Delete",
        retry: "Retry",
        tryAgain: "Try again",
        uploadFailed: "Upload failed, please try again",
        dragAndDrop: "or drag and drop",
        maxFileSize: "Max file size: {{size}}",
        acceptedFormats: "Accepted formats: {{formats}}",
        uploadSuccess: "File uploaded successfully",
        uploadError: "Error uploading file",
    },
    commandMenu: {
        title: "Command Menu",
        searchPlaceholder: "Search...",
        removeFilter: "Remove filter",
        noResults: "No results found",
        searching: "Searching…",
        startTyping: "Start typing to search...",
        entities: {
            container: "Container",
            sender: "Sender",
            receiver: "Receiver",
            account: "Account",
            address: "Address Book",
            document: "Documents",
        },
        sections: {
            folders: "EveDrive — Folders",
            containers: "Containers",
            documents: "EveDrive — Documents",
            issues: "Issues",
            review: "Review Center",
            businessPartners: "Business partners",
            contacts: "Address book",
            accounts: "Accounts",
        },
    },
    account: {
        viewProfile: "View profile",
        documentation: "Documentation",
        switchCompany: "Switch company",
        signOut: "Sign out",
    },
    aiChat: {
        title: "Summon Eve",
        placeholder: "Ask Eve...",
        ariaLabel: "AI Chat",
        welcome: "Hello, how can I help you?",
        welcomeSubtitle: "Choose an action to get started",
        initialMessage: "Hello! I'm Eve. How can I help you navigate your operations today?",
        actions: {
            createContainer: "Create Container",
            createOrder: "Create Order",
            createQuoteRequest: "Create Quote Request",
            createQuote: "Create Quote",
            checkColdChain: "Check for Cold Chain",
            financialRisks: "Financial Risks",
            missingDocs: "Missing Docs",
            containerUpdates: "Container updates",
            containerRiskAssessment: "Container risk assessment",
            copy: "Copy",
            copied: "Copied to clipboard",
            copyFailed: "Copy failed",
            regenerate: "Regenerate",
            edit: "Edit",
            delete: "Delete",
            deleteConfirm: "Are you sure you want to delete this message?",
            stop: "Stop",
        },
        quickActionPrompts: {
            createContainer:
                "I need to create a new container with ID {{containerId}}. Please add it to the system if it does not already exist, then ask me if I want to add more details (origin port, destination port, ETA, etc.).",
            containerRiskAssessment: "Show me containers with medium or high risk level that require my attention.",
            missingDocs: "List containers that have missing documents or validation errors so I can review them manually.",
            containerUpdates: "Give me an update on the status of containers not yet delivered.",
        },
        createContainerModal: {
            title: "Create container",
            containerIdPlaceholder: "Container ID",
            submit: "Continue",
            cancel: "Cancel",
        },
        you: "You",
        assistant: "Eve Care",
        attach: "Attach",
        emoji: "Emoji",
        scrollToBottom: "Scroll to bottom",
        toggleQuickActions: "Toggle quick actions",
        reasoning: {
            thinking: "Thinking",
            thinkingInProgress: "Thinking in progress",
            toolCall: "Using tool",
            ragSearch: "Searching knowledge",
            delegating: "Delegating",
            responding: "Responding",
            steps: "Reasoning Steps",
            activity: "Agent Activity",
            activeAgents: "Active Agents",
            toolCalls: "Tool Calls",
            delegations: "Agent Delegations",
            waiting: "Waiting for information...",
        },
        newChat: "New chat",
        chatHistory: "Chat history",
        searchChatsLabel: "Search chats",
        searchChatsPlaceholder: "Search by title or message…",
        noSearchResults: "No chats match your search",
        noChats: "No chats yet",
        untitledChat: "Untitled chat",
        messageCount: "{{count}} messages",
        closeTab: "Close tab",
        deleteChat: "Delete chat",
        confirmDelete: "Are you sure you want to delete this chat?",
        renameChat: "Rename chat",
        chatTitle: "Chat title",
        saveTitle: "Save title",
        editTitle: "Edit title",
        select: "Select",
        star: "Add to favorites",
        unstar: "Remove from favorites",
        rename: "Rename",
        delete: "Delete",
        selectAll: "Select all",
        deselectAll: "Deselect all",
        selectedCount: "{{count}} selected",
        bulkDelete: "Delete selected",
        confirmBulkDelete: "Delete {{count}} chats?",
        cancelEdit: "Cancel",
        wizard: {
            confirmed: "Perfect! Let's continue...",
            enterValue: "Enter value...",
            create: "Create",
            cancelled: "Wizard cancelled. How can I help you?",
            notSpecified: "Not specified",
            container: {
                containerNumber: "What is the container number?",
                routeFrom: "Which city does the container depart from?",
                routeTo: "Which city is the container going to?",
                eta: "What is the expected arrival date (ETA)?",
                valueAmount: "What is the container value?",
                valueCurrency: "Which currency do you want to use?",
                status: "What is the container status?",
                receiverId: "Which receiver do you want to select?",
                shippingCompany: "Which shipping company? (optional)",
                review: "Summary:\n- Container Number: {{containerNumber}}\n- From: {{routeFrom}}\n- To: {{routeTo}}\n- ETA: {{eta}}\n- Value: {{valueAmount}} {{valueCurrency}}\n- Status: {{status}}\n- Receiver: {{receiver}}\n- Shipping Company: {{shippingCompany}}",
                success: "Container created successfully!",
                completed: "Container created! Redirecting...",
            },
            order: {
                shipperId: "Which shipper do you want to select?",
                targetDate: "What is the target date for the order?",
                packingListRequested: "What details do you want in the packing list?",
                notes: "Additional notes (optional):",
                review: "Summary:\n- Shipper: {{shipper}}\n- Target Date: {{targetDate}}\n- Packing List: {{packingList}}\n- Notes: {{notes}}",
                success: "Order created successfully!",
                completed: "Order created! Redirecting...",
            },
            quoteRequest: {
                subject: "What is the subject of the quote request?",
                body: "Enter the quote request text:",
                recipients: "Select the recipient freight forwarders:",
                review: "Summary:\n- Subject: {{subject}}\n- Body: {{body}}\n- Recipients: {{recipients}}",
                success: "Quote request created successfully!",
                completed: "Request created! Redirecting...",
            },
            quoteResponse: {
                selectQuote: "Which quote request do you want to respond to?",
                usingContext: "I'm responding to the request: {{subject}}",
                responseSubject: "What is the response subject?",
                responseBody: "Enter the response text:",
                review: "Summary:\n- Request: {{quoteSubject}}\n- Response Subject: {{responseSubject}}\n- Response Body: {{responseBody}}",
                success: "Quote created successfully!",
                completed: "Quote created! Redirecting...",
            },
        },
    },
    stats: {
        vsLastMonth: "vs last month",
    },
    buttons: {
        submit: "Submit",
        cancel: "Cancel",
        save: "Save",
        delete: "Delete",
        edit: "Edit",
        create: "Create",
        update: "Update",
        add: "Add",
        remove: "Remove",
        close: "Close",
        back: "Back",
        next: "Next",
        previous: "Previous",
        confirm: "Confirm",
        logout: "Logout",
        login: "Log in",
        reset: "Reset",
        search: "Search",
        filter: "Filter",
        clear: "Clear",
        apply: "Apply",
        upload: "Upload",
        download: "Download",
        view: "View",
        share: "Share",
        send: "Send",
        invite: "Invite",
        accept: "Accept",
        reject: "Reject",
    },
    form: {
        required: "Required field",
        optional: "Optional",
        invalid: "Invalid value",
        emailInvalid: "Invalid email address",
        passwordTooShort: "Password must be at least 8 characters",
        selectPlaceholder: "Select an option...",
        searchPlaceholder: "Search...",
        noResults: "No results found",
        loading: "Loading...",
        errors: {
            allFieldsRequired: "All fields are required",
            amountInvalid: "Amount must be a number greater than 0",
        },
    },
    validation: {
        required: "This field is required",
        email: "Please enter a valid email address",
        minLength: "Must be at least {{count}} characters",
        maxLength: "Must be at most {{count}} characters",
        pattern: "Invalid format",
    },
    errors: {
        generic: "An error occurred",
        network: "Network error. Please try again.",
        unauthorized: "Unauthorized access",
        notFound: "Resource not found",
        serverError: "Server error. Please try again later.",
        unknown: "Unknown error occurred",
    },
    messages: {
        success: "Operation completed successfully",
        saved: "Saved successfully",
        deleted: "Deleted successfully",
        created: "Created successfully",
        updated: "Updated successfully",
        loading: "Loading...",
        noData: "No data available",
        confirmDelete: "Are you sure you want to delete this item?",
    },
    date: {
        today: "Today",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        thisWeek: "This week",
        thisMonth: "This month",
        thisYear: "This year",
    },
    language: "Language",
    changeLanguage: "Change language",
    english: "English",
    italiano: "Italiano",
    pdfViewer: {
        prev: "Prev",
        next: "Next",
        page: "Page",
        addRectangle: "Add Rectangle",
        addRectangleHere: "Add rectangle here",
        loadingPdf: "Loading PDF...",
    },
    signOut: {
        confirm: {
            title: "Confirm Sign Out",
            message: "Are you sure you want to sign out? You will need to log in again to use the application.",
        },
    },
    accountSwitch: {
        switching: "Switching account...",
    },
    orderAccept: {
        confirmCreateQuotes: {
            title: "Create quote requests",
            message: "Do you want to automatically create quote requests based on this order's specifications?",
            createQuotes: "Yes, create requests",
            acceptOnly: "No, accept order only",
        },
        creatingQuotes: "Creating quote requests",
    },
    theme: "Theme",
    themeLight: "Light",
    themeDark: "Dark",
    themeSystem: "System",
    modal: {
        close: "Close",
        cancel: "Cancel",
        confirm: "Confirm",
        delete: "Delete",
        ok: "OK",
    },
    askEve: {
        title: "Ask Eve",
        containerDebug: {
            title: "Debug container",
            button: "Debug container",
            needIds:
                "If you are not on a container detail page, search by B/L or booking number and pick a row from the list.",
            blOrBooking: "B/L or booking number",
            searchPlaceholder: "Search B/L, booking, container…",
            selected: "Container selected",
            loading: "Loading…",
            noResults: "No containers found",
            risk: "Assess risk",
        },
    },
    controlHub: {
        title: "Control Hub",
    },
};
